import "./index.scss";

import React from "react";

import FooterBottom from "./bottom";
import FooterTop from "./top";

export default function Component() {
	return (
		<footer className="footer">
			<FooterTop />
			<FooterBottom />
		</footer>
	);
}
